export const user = {
    authenticateUser: {
      url: "profile",
      method: "GET",
      data: null,
    },
}